export const getStimulus = ()=>{
    const stimulusData = {
        "Pure Tone": {
          "500 Hz": "/assets/audio/500T.wav",
          "1 kHz": "/assets/audio/1T.wav",
          "2 kHz": "/assets/audio/2T.wav",
          "4 kHz": "/assets/audio/4T.wav",
        
        },
        "Noise": {
          "White": "/assets/audio/White.wav",
          "500 Hz": "/assets/audio/NBN500.wav",
          "1000 Hz": "/assets/audio/NBN1000.wav",
          "2000 Hz": "/assets/audio/NBN2000.wav",
          "4000 Hz": "/assets/audio/NBN4000.wav",
        },
        
        "Ling Sound": {
          "a": "/assets/audio/1.wav",
          "i": "/assets/audio/2.wav",
          "u": "/assets/audio/3.wav",
          "m": "/assets/audio/4.wav",
          "s": "/assets/audio/5.wav",
          "sh": "/assets/audio/6.wav",
        },
         "PB Words": {
          "1 word": "/assets/audio/8.wav",
          "2 word": "/assets/audio/8.wav",
          "3 word": "/assets/audio/8.wav",
          "4 word": "/assets/audio/8.wav",
          "5 word": "/assets/audio/7.wav",
          "6 word": "/assets/audio/7.wav",
          "7 word": "/assets/audio/7.wav",
          "8 word": "/assets/audio/7.wav",
          "9 word": "/assets/audio/7.wav",
          "10 word": "/assets/audio/7.wav",
          "11 word": "/assets/audio/7.wav",
          "12 word": "/assets/audio/7.wav",
          "13 word": "/assets/audio/7.wav",
          "14 word": "/assets/audio/7.wav",
          "15 word": "/assets/audio/7.wav",
          "16 word": "/assets/audio/7.wav",
          "17 word": "/assets/audio/7.wav",
          "18 word": "/assets/audio/7.wav",
          "19 word": "/assets/audio/7.wav",
          "20 word": "/assets/audio/7.wav",
          "21 word": "/assets/audio/7.wav",
          "22 word": "/assets/audio/7.wav",
          "23 word": "/assets/audio/7.wav",
          "24 word": "/assets/audio/7.wav",
          "25 word": "/assets/audio/7.wav",
        }
      };

      return stimulusData;
}